
import type { SVGProps } from "react";
import Image from "next/image";

export function Logo(props: { className?: string }) {
  return (
    <Image
      src="https://vixrewards.online/logovix.png"
      alt="VixRewards Logo"
      width={120}
      height={120}
      className={props.className}
      priority
    />
  );
}


export const GoogleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google</title>
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
    />
    <path fill="none" d="M1 1h22v22H1z" />
  </svg>
);

export const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="#1877F2"
  >
    <title>Facebook</title>
    <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116c.732 0 1.325-.593 1.325-1.325V1.325C24 .593 23.407 0 22.675 0z" />
  </svg>
);


export const DiscordLogoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 245 245"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        fill="#5865F2"
    >
        <title>Discord</title>
        <path d="M206.315 38.685c-20.32-13.742-43.93-23.23-69.48-28.143a.56.56 0 0 0-.58.077c-.12.08-.2.21-.23.344-4.88 19.95-12.63 51.34-12.63 51.34s-28.16-10.35-43.9-20.73C74.615 38.985 69.375 36.6 69.375 36.6c-1.37 0-2.65.89-3.1 2.12-.55 1.43-.1 3.16.98 4.1 15.65 13.56 32.1 27.61 32.1 27.61s-4.63 9.4-8.81 18.25c-15.35-4.85-26.9-10.4-26.9-10.4-1.44-.6-3.08-.22-4.14.93-.95 1.15-.95 2.83 0 3.98 2.33 2.75 5.1 5.3 8.24 7.66 9.4 6.9 19.3 12.7 29.5 17.5 7.9 3.7 16.1 6.8 24.5 9.2 1.1.3 1.9.5 1.9.5a3.2 3.2 0 0 0 1.2.2c1.4 0 2.6-1 3-2.4.1-.4 4.8-19.5 4.8-19.5s12.5 4.3 29.1 10.3c1.4.5 2.9.2 3.9-.7s1.3-2.5.7-3.9c-.3-.7-8.2-13-8.2-13s2.1-4.2 4-8.2c14.2 4.4 29.3 10.9 29.3 10.9 1.4.6 3.08.2 4.1-.9.9-1.2.9-2.9 0-4-2.3-2.7-5.1-5.3-8.2-7.6-9.5-6.9-19.3-12.7-29.6-17.5-7.8-3.7-16-6.8-24.4-9.2-1.1-.3-2.1-.5-2.1-.5-2-1-4.3-1.6-6.7-1.6-25.5 0-49.5 9.8-67.4 27.7-14 14-23.2 32.2-26.2 52.4-2.1 14.5-.4 29.2 5.2 43 5.3 13.2 13.6 24.9 24.3 34.3 11.5 10.2 25.4 17.8 40.5 22.4 14.8 4.5 30.2 5.9 45.3 4.1 18.5-2.1 35.9-8.4 51.1-18.2 14.3-9.1 26.6-21.2 36.1-35.3 8.8-13.1 14.5-27.9 16.6-43.2 2.3-16.2.7-32.7-5.3-48.2zM122.5 180.5c-15.3 0-27.7-13.2-27.7-29.5s12.4-29.5 27.7-29.5c15.3 0 27.7 13.2 27.7 29.5s-12.4 29.5-27.7 29.5zm61.2 0c-15.3 0-27.7-13.2-27.7-29.5s12.4-29.5 27.7-29.5c15.3 0 27.7 13.2 27.7 29.5s-12.4 29.5-27.7 29.5z" />
    </svg>
);
